"use strict";
exports.__esModule = true;
exports.DeparturePointLinkType = exports.AnnotationCategory = exports.OtherAnnotationCategory = exports.OutageAnnotationCategory = exports.PriceAnnotationCategory = exports.AvailabilityAnnotationCategory = void 0;
var AvailabilityAnnotationCategory;
(function (AvailabilityAnnotationCategory) {
    /** This offer is selling out quickly, book your tickets now! */
    AvailabilityAnnotationCategory["SellingOut"] = "selling-out";
    /** This schedule is new and the operator wishes to promote it as such */
    AvailabilityAnnotationCategory["NewSchedule"] = "new-schedule";
    /** A schedule that is not normally offered and not only to serve a specific event */
    AvailabilityAnnotationCategory["SpecialSchedule"] = "special-schedule";
    /** This is a direct "express" journey between the two cities and is usually marketed as such */
    AvailabilityAnnotationCategory["Express"] = "express";
    /** Special service due to an event (festival, sporting event, parade, etc) */
    AvailabilityAnnotationCategory["Event"] = "event";
})(AvailabilityAnnotationCategory = exports.AvailabilityAnnotationCategory || (exports.AvailabilityAnnotationCategory = {}));
var PriceAnnotationCategory;
(function (PriceAnnotationCategory) {
    /** A general promotion by the operator */
    PriceAnnotationCategory["Promo"] = "promo";
    /** The price has recently been dropped */
    PriceAnnotationCategory["PriceDrop"] = "price-drop";
    /** Exclusive deal offered by the supplier */
    PriceAnnotationCategory["ExclusiveDeal"] = "exclusive-deal";
    /** This price is lower than usual based on historical data */
    PriceAnnotationCategory["LowerThanUsual"] = "lower-than-usual";
    /** This price is about to increase, book your tickets now! */
    PriceAnnotationCategory["PriceIncreasingSoon"] = "price-increasing-soon";
})(PriceAnnotationCategory = exports.PriceAnnotationCategory || (exports.PriceAnnotationCategory = {}));
var OutageAnnotationCategory;
(function (OutageAnnotationCategory) {
    /** Segment may be unavailable for booking due to planned maintenance on the data source */
    OutageAnnotationCategory["SourceMaintenance"] = "source-maintenance";
    /** Segment may be unavailable for booking due to a technical issue with the data source */
    OutageAnnotationCategory["TechnicalOutage"] = "source-outage";
    /** Segment may be unavailable for booking due to a service disruption on the route */
    OutageAnnotationCategory["ServiceDisruption"] = "service-disruption";
})(OutageAnnotationCategory = exports.OutageAnnotationCategory || (exports.OutageAnnotationCategory = {}));
var OtherAnnotationCategory;
(function (OtherAnnotationCategory) {
    /** This journey is marked as recommended by Busbud. */
    OtherAnnotationCategory["Recommended"] = "recommended";
    /** Trip is an alternative route from original search. */
    OtherAnnotationCategory["AlternativeRoute"] = "alternative-route";
    /** Additional information provided for the trip through external links. */
    OtherAnnotationCategory["DeparturePointLinks"] = "departure-point-links";
    /** Operator related annotation. */
    OtherAnnotationCategory["OperatorRelated"] = "operator-related";
    /** Trip is an alternative route from original search but origin and destination cities are the same. */
    OtherAnnotationCategory["Fallback"] = "fallback";
})(OtherAnnotationCategory = exports.OtherAnnotationCategory || (exports.OtherAnnotationCategory = {}));
exports.AnnotationCategory = Object.assign({}, AvailabilityAnnotationCategory, PriceAnnotationCategory, OutageAnnotationCategory, OtherAnnotationCategory);
var DeparturePointLinkType;
(function (DeparturePointLinkType) {
    /** External details and instructions about the departure stop */
    DeparturePointLinkType["StopDetails"] = "stop_details";
})(DeparturePointLinkType = exports.DeparturePointLinkType || (exports.DeparturePointLinkType = {}));
